import * as React from "react";
import { forwardRef } from "react";
const SvgFileSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M21.5 0H3.5C2.6 0 2 0.6 2 1.5V22.5C2 23.4 2.6 24 3.5 24H15.5L23 16.5V1.5C23 0.6 22.4 0 21.5 0ZM5 3H20V15H14V21H5V3Z", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgFileSmall);
export default ForwardRef;
